var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "red-off-circle-small.86ddf02b.png","uri@2x": __webpack_public_path__ + "red-off-circle-small.7fbb8694.png","uri@3x": __webpack_public_path__ + "red-off-circle-small.dc2e6264.png",
    width: 20,
    height: 20
});